/* ar-ao.js: Block "Upgrade your release" auf der Produktseite (Theme-Kopie, Bauauftrag A5, 06.10.2026; Runde 2 UI = A6, 06.10.2026; Produktseite next level = A9, 07.10.2026; Kritik-Runde = A11, 07.10.2026).
   Herkunft: shop/addons-prototyp/ar-addons.js. Haengt am Formular [data-ar-prod-form] aus sections/ar-product.liquid, laedt nach ar.js und nach ar-ao-viewer.js (alle defer).
   - Schalter je Add-on (Release Kit, Profile Banner Pack, Tracklist), Stilwahl (Kit, fuenf Stile), Tracklist aus einzelnen Zeilen + Notes, Summenzeile, Upsell-Blatt nach "Add to cart".
   - Karussell, Videos und der Viewer (Klick auf das Kartenbild oder "Preview") liegen in ar-ao-viewer.js (window.ARAO). Hier wird nur der Host gesetzt: welche Add-ons es gibt, ob eins an ist, umschalten, welcher Stil gewaehlt ist.
   - A6: grosser Stil-Viewer (Story, Post 4:5, Square, Wide im gewaehlten Stil), Add-on-Folien in der Produktgalerie links.
   - A32 (07.10.2026): Handy (bis 560 px): Kit-Karte als Teaser-Zeile mit gefaecherten Karten; ktSet(open) klappt .ar-ao__ktfold auf und zu (Kachel / Textknopf [data-ao-kt], Anschalten des Schalters oeffnet, Ausschalten schliesst nicht),
     ktFanFor(stil) tauscht die Fachkarten, das Beispielvideo spielt nur bei offenem Inhalt (kitSync). Ab 561 px ohne Wirkung.
   - A19 (07.10.2026): Kit-Karte mit EINEM Zustand. Das Handy mit dem Beispielvideo spielt, sobald es zur Haelfte im Bild ist, auch bei ausgeschaltetem Schalter (kein Panel, keine Chips mehr).
     Die fuenf Stil-Kacheln der Karte waehlen den Stil (Kachel, Handy-Video, Bestell-Eigenschaft Style, Bild der Kit-Folie in der Galerie). Ein Tipp auf eine Kachel springt am Rechner zur Kit-Folie (Ueberblenden, nur opacity),
     am Handy bleibt die Galerie, wo sie ist, nur das Bild der Folie wechselt. "See all 8 graphics" oeffnet den Viewer beim ersten Bild des Stils. Die Kit-Folie (data-ao-kitslide) hat je Stil eine Adresse (data-k-<stil>).
   - A26 (07.10.2026): fold(f, show) fuer weiches Auf und Zu (Tracklist-Bereich, Namensfelder, Hinweis; .ar-ao__fold mit is-open/is-done, hidden erst nach dem Schliessen), pop(card) setzt beim Einschalten einmalig .is-pop
     (Lichtstreif, Abzeichen-Pop, Puls-Ring, ~700 ms; Glimmen und Rand laufen ueber .is-on in ar-ao.css). Beides nicht beim Laden und nicht bei prefers-reduced-motion.
   - A24 (07.10.2026): Die Kit-Folie der Galerie zeigt im Handy des Bretts das echte Video (data-ao-kv, kitvid-<stil>.mp4, Adressen data-kv-<stil> / data-kvp-<stil> an der Folie). Es laedt erst, wenn die Folie das erste Mal gezeigt wird,
     und spielt nur, wenn die Folie aktiv und die Buehne zur Haelfte sichtbar ist (nie bei offenem Viewer oder prefers-reduced-motion; dann bleibt das Brett wie es ist). Solange es spielt, pausiert das Handy-Video der Karte (nie zwei Videos).
     Der Schalter der Kit-Karte braucht kein JS fuer die Belohnung: Glimmen und "Added ✓" haengen in ar-ao.css an .is-on der Karte. "See all 8 graphics + video" ist ein Knopf (data-ao-all), gleiche Funktion.
   - A15 (08.10.2026): Das Handy der Kit-Karte spielt kitvid-<Stil>.mp4 der gewaehlten Stilrichtung (harter Loop, Quelle wechselt mit der Stilwahl, Chips oder Kacheln). Es laeuft hoechstens EIN Video der Seite ausserhalb des Viewers
     (das Handy), nur solange es zu mindestens der Haelfte im Bild ist, nie bei eingeschaltetem Kit (dann steht die Live-Stilvorschau da), offenem Viewer oder prefers-reduced-motion.
     Mini-Vorschaubilder der Galerie 72 bis 80 px: srcset 160w/240w (data-thumb, data-thumb2), die Reihe wischt horizontal mit Scroll-Snap, das aktive Bild wird in die Mitte geschoben.
     Galerie ohne Video. Der nicht-passive touchmove-Hoerer fuers Sortieren haengt nur an der Tracklist, nicht mehr am Dokument.
   - A13 (08.10.2026): Die Stilvorschau hat nur noch die vier Formate des eigenen Covers (die 5. Folie "Video" aus A11 ist raus, Videos gibt es im Viewer).
     Galerie links ruhig und fest: Buehne 1:1, darunter EINE feste Zeile (Titel, graue Unterzeile, Knopf rechts, bei Folien ohne Knopf bleibt der Platz leer), darunter Pfeil, Mini-Vorschaubilder, Pfeil. Keine Punkte, kein Zaehler. Am Handy wischen.
   - A9: Galerie mit Mini-Vorschaubildern, Tracklist-Zeilen mit Griff zum Ziehen (Pointer Events, am Handy Long-Press und Auto-Scroll, Tastatur: Griff fokussieren und Pfeiltasten),
     Enter legt die naechste Zeile an, Einfuegen mehrerer Zeilen teilt auf. Variante B der Oberflaeche (Schritte, neutrale Rahmen) ist Standard, ?ao_ui=1 zeigt A.
   - A30 (07.10.2026): die schwebende Summenleiste .ar-ao-fsum entfaellt; die Kaufleiste [data-ar-buybar] zeigt den Gesamtpreis inkl. Add-ons und klein "incl. add-ons" (barSync, MutationObserver auf [data-ar-buybar-price]).
     Spar-Modus (saveData) wie reduzierte Bewegung (NOAUTO): keine Videos von selbst. Nur ein Video gleichzeitig: ar-ao-viewer.js.
   - Eingabefelder tragen kein name-Attribut (ar.js deaktiviert beim Absenden jedes Feld ohne data-ar-eigen).
   - Absenden: Zuerst gehen die Add-on-Zeilen per fetch('/cart/add.js', {items: [...]}) in den Warenkorb, danach schickt das Cover-Formular
     klassisch ab (multipart, so geht die Logo-Datei nie ueber fetch). Schlaegt das Hinzufuegen fehl, geht das Cover nicht ab.
   - Zeilen mit data-preview="1" (Produkt noch nicht veroeffentlicht, nur in Vorschau-Themes) haben keine Variant-ID und gehen nie in den Warenkorb.
   - Artist Name und Title der Add-on-Zeilen: aus den Feldern des Covers, wenn die aktiv sind; sonst aus den Feldern des Blocks (Pflicht).
   - Eigenschaft Tracks: je Zeile "1. Titel (feat. X)", leere Zeilen fallen weg, mindestens ein Titel ist Pflicht. */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* A27 (07.10.2026): Seitenverlauf beim Waehlen von Buyout. Beobachtet den Buyout-Knopf der Lizenzwahl (.is-on setzt ar.js). Beim ersten Mal legt es die feste Ebene .ar-ao-pagebg mit drei Flecken an
     und schaltet sie mit .is-on (CSS in ar-ao.css, Block A27: opacity + transform, kein filter). html.ar-ao-buyout zeigt den Zustand, html.ar-ao-pagehidden haelt die Flecken an, solange der Tab verdeckt ist.
     Haengt nicht am Add-on-Block, laeuft also auch auf Seiten ohne Add-ons. */
  (function () {
    var btn = $('.ar-prodform .ar-opt__b--one');
    if (!btn) return;
    var layer = null, html = doc.documentElement;
    function sync() {
      var on = btn.classList.contains('is-on');
      if (on && !layer) {
        layer = doc.createElement('div');
        layer.className = 'ar-ao-pagebg';
        layer.setAttribute('aria-hidden', 'true');
        ['a', 'b', 'c'].forEach(function (k) {
          var s = doc.createElement('span');
          s.className = 'ar-ao-pagebg__s ar-ao-pagebg__s--' + k;
          layer.appendChild(s);
        });
        doc.body.appendChild(layer);
        void layer.offsetWidth;
      }
      if (layer) layer.classList.toggle('is-on', on);
      html.classList.toggle('ar-ao-buyout', on);
    }
    if (window.MutationObserver) new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
    doc.addEventListener('visibilitychange', function () { html.classList.toggle('ar-ao-pagehidden', doc.hidden); });
    sync();
  })();

  var root = $('[data-ar-addons]');
  if (!root) return;
  var ARAO = window.ARAO;
  if (!ARAO) return;
  var form = root.closest('form');
  if (!form) return;
  var handle = root.getAttribute('data-handle') || '';
  var priceEl = $('[data-ar-prod-price]');
  var buy = $('[data-ar-prod-buy]', form);
  var coverArtist = $('[data-ar-prod-artist]', form);
  var coverTitle = $('[data-ar-prod-title]', form);
  var SESSION_KEY = 'ar-ao-upsell';
  var REDUCED = ARAO.REDUCED;
  /* A30: kein Video startet von selbst bei reduzierter Bewegung ODER Spar-Modus (navigator.connection.saveData) */
  var NOAUTO = !!ARAO.QUIET;
  var MAX_TRACKS = 30;
  var carousel = ARAO.carousel, stack = ARAO.stack;

  /* ------------------------------------------------------------ Oberflaeche: B (Standard) oder A (?ao_ui=1, merkt sich die Sitzung) */
  var UI = '2';
  try {
    var qm = /[?&]ao_ui=(\d)/.exec(location.search);
    if (qm) { if (qm[1] === '1') sessionStorage.setItem('ar-ao-ui', '1'); else sessionStorage.removeItem('ar-ao-ui'); }
    UI = sessionStorage.getItem('ar-ao-ui') === '1' ? '1' : '2';
  } catch (e) { UI = /[?&]ao_ui=1/.test(location.search) ? '1' : '2'; }
  doc.documentElement.classList.toggle('ar-ao-ui2', UI === '2');

  /* Blaetter liegen im Snippet noch im Formular; ins body, damit sie nicht zum Formular gehoeren */
  $$('dialog[data-ar-ao-upsell]', form).forEach(function (n) { doc.body.appendChild(n); });
  var upsell = $('dialog[data-ar-ao-upsell]');

  var KEYS = ['kit', 'banner', 'tracks'];
  var card = {}, chk = {};
  KEYS.forEach(function (k) { card[k] = $('[data-ao="' + k + '"]', root); chk[k] = card[k] && $('[data-ao-chk]', card[k]); });
  var S = { kit: false, banner: false, tracks: false, style: 'xerox' };
  var sumEl = $('[data-ao-sum]', root), errEl = $('[data-ao-err]', root), noteEl = $('[data-ao-note]', root), namesEl = $('[data-ao-names]', root);
  var notesEl = $('[data-ao-notes]', root);
  var artistEl = $('[data-ao-artist]', root), titleEl = $('[data-ao-title]', root);
  var STYLES = ['xerox', 'studio', 'holo', 'folie', 'clean'];

  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function cents(k) { return card[k] ? (parseInt(card[k].getAttribute('data-cents'), 10) || 0) : 0; }
  function coverCents() { return priceEl ? (parseInt((priceEl.textContent || '').replace(/\D/g, ''), 10) || 0) : 0; }
  function nameOf(sel, attr, val) { var el = $(sel.replace('%', val), root); return el ? el.getAttribute(attr) : val; }
  function openDlg(d) { ARAO.openDlg(d); }
  function closeDlg(d, silent) { if (!d) return; if (window.AR && window.AR.closeDialog) window.AR.closeDialog(d, !!silent); else if (d.close) d.close(); }
  function anyOn() { return KEYS.some(function (k) { return S[k] && card[k]; }); }
  /* Hat das Cover gerade eigene Namensfelder? Instant-Seiten: keine. 24 Hour: ja, ausser "No text on it" oder text-freie Fassung (ar.js setzt sie disabled). */
  function coverHasNames() { return !!(coverArtist && !coverArtist.disabled); }
  function namesNeeded() { return anyOn() && !coverHasNames(); }
  /* Steht ein Name auf dem Kit? Nur wenn er in den Feldern des Blocks getippt ist (Instant oder 24 Hour mit "No text on it"). Dann gilt die Xerox-Ebene mit Tape-Feld. */
  function nameOnKit() { return !!(namesNeeded() && artistEl && artistEl.value.trim()); }
  function applyGround() {
    var w = nameOnKit();
    $$('img[data-ao-mit]').forEach(function (im) {
      var u = im.getAttribute(w ? 'data-ao-mit' : 'data-ao-ohne');
      if (u && im.getAttribute('src') !== u) im.setAttribute('src', u);
    });
  }

  /* Host fuer den Viewer: welche Add-ons es hier gibt, ob eins an ist, umschalten */
  ARAO.host = {
    has: function (k) { return !!card[k]; },
    isOn: function (k) { return !!S[k]; },
    toggle: function (k) { if (card[k]) { toggle(k, !S[k]); hideErr(); } },
    style: function () { return S.style; },
    setStyle: function (name) { if (STYLES.indexOf(name) >= 0 && name !== S.style) selectStyle(name); }
  };

  /* ------------------------------------------------------------ Zustand */
  function update() {
    var any = anyOn();
    fold(noteEl && noteEl.closest('[data-ao-fold]'), any);
    fold(namesEl && namesEl.closest('[data-ao-fold]'), namesNeeded());
    applyGround();
    var total = coverCents(), parts = ['Cover ' + money(total)];
    KEYS.forEach(function (k) { if (S[k] && card[k]) { total += cents(k); parts.push(card[k].getAttribute('data-label') + ' ' + money(cents(k))); } });
    if (sumEl) {
      sumEl.hidden = UI === '2' ? false : !any;
      sumEl.textContent = '';
      var add = function (txt, cls, tag) { var s = doc.createElement(tag || 'span'); if (cls) s.className = cls; s.textContent = txt; sumEl.appendChild(s); };
      if (UI === '2') {
        add('Total', 'ar-ao__sum-l');
        add(money(total), 'ar-ao__sum-v', 'b');
        if (any) add(parts.join(' + '), 'ar-ao__sum-d');
      } else if (any) {
        add('Cover ' + money(coverCents()));
        KEYS.forEach(function (k) { if (S[k] && card[k]) { add('+', 'op'); add(card[k].getAttribute('data-label') + ' ' + money(cents(k))); } });
        add('=', 'op');
        add(money(total), '', 'b');
      }
    }
    barSync(any, total);
    galSync();
    kitSync();
    if (ARAO.syncViewer) ARAO.syncViewer();
  }
  /* A26: weiches Auf und Zu (Tracklist-Bereich, Namensfelder, Hinweis). f = Rahmen [data-ao-fold] mit .ar-ao__foldin darin.
     Auf: hidden weg, ein Frame warten, dann .is-open (Hoehe 0fr -> 1fr per CSS, 320 ms); nach 340 ms .is-done (overflow sichtbar).
     Zu: .is-open weg, inert gegen Fokus in den schliessenden Bereich, hidden erst nach 340 ms. Beim Laden und bei prefers-reduced-motion ohne Animation. */
  var ready = false;
  function fold(f, show) {
    if (!f || !!f.__open === !!show) return;
    f.__open = !!show;
    clearTimeout(f.__t);
    var instant = REDUCED || !ready;
    if (show) {
      f.hidden = false;
      if ('inert' in f) f.inert = false;
      if (instant) { f.classList.add('is-open', 'is-done'); return; }
      f.classList.remove('is-done');
      void f.offsetHeight;
      f.classList.add('is-open');
      f.__t = setTimeout(function () { f.classList.add('is-done'); }, 340);
    } else {
      f.classList.remove('is-open', 'is-done');
      if ('inert' in f) f.inert = true;
      if (instant) { f.hidden = true; return; }
      f.__t = setTimeout(function () { if (!f.__open) f.hidden = true; }, 340);
    }
  }
  /* A26: Belohnung beim Einschalten. .is-pop (Lichtstreif, Abzeichen-Pop, Puls-Ring) laeuft einmal ~700 ms, danach bleibt nur der ruhige Endzustand (.is-on). Nicht beim Laden, nicht bei reduzierter Bewegung. */
  function pop(c) {
    if (!c || REDUCED || !ready) return;
    c.classList.remove('is-pop');
    void c.offsetWidth;
    c.classList.add('is-pop');
    clearTimeout(c.__popT);
    c.__popT = setTimeout(function () { c.classList.remove('is-pop'); }, 900);
  }
  function unpop(c) { if (!c) return; clearTimeout(c.__popT); c.classList.remove('is-pop'); }
  function toggle(k, on) {
    if (!card[k]) return;
    var was = !!S[k];
    S[k] = !!on;
    chk[k].checked = !!on;
    card[k].classList.toggle('is-on', !!on);
    var panel = $('[data-ao-panel]', card[k]);
    if (panel) fold(panel, !!on);
    if (on && !was) pop(card[k]); else if (!on) unpop(card[k]);
    update();
  }
  KEYS.forEach(function (k) {
    if (!card[k]) return;
    chk[k].addEventListener('change', function () { toggle(k, chk[k].checked); hideErr(); if (k === 'kit' && chk[k].checked) ktSet(true); });
    toggle(k, chk[k].checked);
  });
  if (priceEl && window.MutationObserver) new MutationObserver(update).observe(priceEl, { childList: true, characterData: true, subtree: true });
  /* ar.js schaltet die Namensfelder des Covers per disabled um (No text, text-frei): Block-Felder folgen */
  if (coverArtist && window.MutationObserver) new MutationObserver(update).observe(coverArtist, { attributes: true, attributeFilter: ['disabled'] });
  if (artistEl) artistEl.addEventListener('input', applyGround);

  /* ------------------------------------------------------------ Stilwahl und grosser Stil-Viewer im Kit-Bereich */
  function radios(group, itemSel, pick) {
    if (!group) return;
    group.addEventListener('keydown', function (ev) {
      if (!/^Arrow(Left|Right|Up|Down)$/.test(ev.key)) return;
      var items = $$(itemSel, group), cur = doc.activeElement && doc.activeElement.closest(itemSel), i = items.indexOf(cur);
      if (i < 0) return;
      ev.preventDefault();
      var n = items[(i + (/Left|Up/.test(ev.key) ? -1 : 1) + items.length) % items.length];
      n.focus(); pick(n);
    });
  }
  /* Video der Seite ausserhalb des Viewers: nur das Handy der Kit-Karte (Beispielvideo). Es laeuft nur, solange es zu mindestens der Haelfte im Bild ist,
     auch bei ausgeschaltetem Schalter (A19: ein Zustand), aber nie bei offenem Viewer oder prefers-reduced-motion. */
  var pvid = $('[data-ao-pvid]', root), pvBtn = pvid && pvid.closest('button'), pvVis = false, pvBad = {};
  function halfVisible(e) { return e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= window.innerHeight * 0.5); }
  /* A24: das Video der Galerie-Folie hat Vorrang. Es spielt nur, wenn die Kit-Folie aktiv und die Buehne zur Haelfte sichtbar ist; dann pausiert das Handy-Video der Karte (nie zwei Videos gleichzeitig). */
  function gvWant() {
    return !!(gal && gal.kv && gal.kvOn && !gal.kvBox.hidden && gal.kitAt && gal.cur === gal.kitAt && gal.kvVis && !NOAUTO && !ARAO.viewerOpen);
  }
  /* A32: Handy (bis 560 px): die Kit-Karte ist zuerst eine Teaser-Zeile (Fachkachel mit gefaecherten Karten). Der Kit-Inhalt (.ar-ao__ktfold, darin das Handy mit dem Video) klappt auf Tippen auf die Kachel
     oder den Textknopf [data-ao-kt] auf und wieder zu, ebenso beim Anschalten des Schalters (nicht beim Ausschalten). Ab 561 px ist der Inhalt immer offen (CSS), dieser Zustand gilt dort nicht.
     Das Beispielvideo im Handy startet erst, wenn der Inhalt offen ist (vorher kein Request fuer die mp4, preload="none"), beim Zuklappen pausiert es. Der Zustand ist nur Darstellung. */
  var ktCard = card.kit, ktFold = ktCard && $('[data-ao-ktfold]', ktCard), ktFan = ktCard && $('[data-ao-ktfan]', ktCard), ktOpenS = false;
  var ktBtns = ktCard ? $$('[data-ao-kt]', ktCard) : [];
  var ktMQ = window.matchMedia ? window.matchMedia('(max-width: 560px)') : null;
  function ktMobile() { return !!(ktMQ && ktMQ.matches); }
  function ktShown() { return !ktFold || !ktMobile() || ktOpenS; }
  function ktInert() { if (ktFold && 'inert' in ktFold) ktFold.inert = ktMobile() && !ktOpenS; }
  function ktSet(open) {
    if (!ktFold) return;
    ktOpenS = !!open;
    ktCard.classList.toggle('is-kt-open', ktOpenS);
    ktBtns.forEach(function (b) {
      b.setAttribute('aria-expanded', ktOpenS ? 'true' : 'false');
      var l = $('[data-ao-ktlbl]', b);
      if (l) l.textContent = ktOpenS ? 'Hide' : 'Choose style';
    });
    ktInert();
    clearTimeout(ktFold.__t);
    if (ktOpenS) {
      ktFold.classList.add('is-open');
      if (REDUCED || !ready) ktFold.classList.add('is-done');
      else ktFold.__t = setTimeout(function () { if (ktOpenS) ktFold.classList.add('is-done'); }, 340);
    } else {
      ktFold.classList.remove('is-open', 'is-done');
    }
    kitSync();
  }
  /* Fachkarten der Kachel folgen dem gewaehlten Stil (Vorlagen <template data-ao-kt-tpl="stil">, die Bilder laden erst beim Einsetzen) */
  function ktFanFor(name) {
    if (!ktFan || ktFan.getAttribute('data-st') === name) return;
    var tpl = $('template[data-ao-kt-tpl="' + name + '"]', ktCard);
    if (!tpl || !tpl.content) return;
    ktFan.textContent = '';
    ktFan.appendChild(tpl.content.cloneNode(true));
    ktFan.setAttribute('data-st', name);
    applyGround();
  }
  if (ktMQ) {
    var ktMQ2 = function () { ktInert(); kitSync(); };
    if (ktMQ.addEventListener) ktMQ.addEventListener('change', ktMQ2); else if (ktMQ.addListener) ktMQ.addListener(ktMQ2);
  }
  ktInert();
  function kitSync() {
    var g = gvWant();
    if (gal && gal.kv) { if (g) ARAO.play(gal.kv); else gal.kv.pause(); }
    if (NOAUTO || ARAO.viewerOpen || g || !ktShown()) { if (pvid) pvid.pause(); return; }
    if (pvid && !pvid.hidden && pvVis) ARAO.play(pvid); else if (pvid) pvid.pause();
  }
  if (pvBtn && window.IntersectionObserver) new IntersectionObserver(function (en) { pvVis = halfVisible(en[en.length - 1]); kitSync(); }, { threshold: [0, 0.25, 0.5, 0.75, 1] }).observe(pvBtn);
  doc.addEventListener('ao-viewer', function () { kitSync(); });
  /* Beispielvideo im Handy: die Quelle folgt der Stilwahl (Poster zuerst), gibt es fuer den Stil keins, steht die Stilvorschau im Handy */
  if (pvid) {
    pvid.setAttribute('data-ao-cur', 'xerox');
    var pvFail = function () { pvBad[pvid.getAttribute('data-ao-cur')] = true; pvFor(S.style); };
    pvid.addEventListener('error', pvFail);
    $$('source', pvid).forEach(function (s) { s.addEventListener('error', pvFail); });
  }
  function pvFor(name) {
    if (!pvid) return;
    var kit = ARAO.data().kit, st = kit && (kit.styles || []).filter(function (s) { return s.key === name; })[0];
    var fb = $('[data-ao-thumb="kit"]', root);
    if (st && st.video && !pvBad[name]) {
      if (pvid.getAttribute('data-ao-cur') !== name) {
        pvid.pause();
        pvid.setAttribute('data-ao-cur', name);
        pvid.poster = st.video.poster;
        var src = $('source', pvid);
        if (src) { src.src = st.video.src; pvid.load(); }
      }
      pvid.hidden = false;
      if (fb) fb.hidden = true;
    } else {
      pvid.pause();
      pvid.hidden = true;
      if (fb) fb.hidden = false;
    }
    kitSync();
  }
  /* A19: Kit-Folie der Galerie. Je Stil stehen die Adressen als data-k-<stil>, -ss (srcset), -t (160x), -t2 (240x) an der Folie (snippets/ar-addons.liquid). */
  var GAL_SIZES = '(min-width: 1600px) 820px, (min-width: 640px) 620px, 100vw';
  function kitVals(el, name) {
    var src = el.getAttribute('data-k-' + name);
    if (!src) return null;
    return { src: src, ss: el.getAttribute('data-k-' + name + '-ss') || '', t: el.getAttribute('data-k-' + name + '-t') || '', t2: el.getAttribute('data-k-' + name + '-t2') || '' };
  }
  function kitImg(el, v) {
    var im = $('img', el);
    if (!im) return;
    im.__aoFb = false;
    if (v.ss) { im.setAttribute('sizes', GAL_SIZES); im.setAttribute('srcset', v.ss); } else { im.removeAttribute('srcset'); im.removeAttribute('sizes'); }
    im.setAttribute('data-ao-fb', v.src);
    im.src = v.src;
  }
  /* Bild, Mini-Vorschaubild und Titel der Kit-Folie auf den gewaehlten Stil stellen. Gibt es fuer den Stil keine Adresse, bleibt das Bild stehen. */
  function kitGal(name) {
    if (!gal || !gal.kitEl) return;
    var v = kitVals(gal.kitEl, name);
    gal.kitEl.setAttribute('data-cap', 'Release Kit · ' + nameOf('[data-ao-tiles] [data-ao-style="%"]', 'data-name', name));
    if (v) {
      kitImg(gal.kitEl, v);
      if (gal.kitTh) { gal.kitTh.__cur = { src: v.t || v.src, src2: v.t2, fb: v.src }; if (gal.kitTh.__put) gal.kitTh.__put(); }
    }
    if (gal.kvOn) kvFor(name);
    galSync();
  }
  /* A24: Video im Handy des Bretts. Quelle und Poster je Stil, erst nach dem ersten Zeigen der Folie. Fehlt eine Adresse, faellt das Video aus, das Brett bleibt wie es ist. */
  function kvFor(name) {
    if (!gal || !gal.kv || !gal.kvOn) return;
    var u = gal.kitEl.getAttribute('data-kv-' + name), p = gal.kitEl.getAttribute('data-kvp-' + name);
    if (!u || !p || gal.kvBad[name] || NOAUTO) { gal.kv.pause(); gal.kvBox.hidden = true; kitSync(); return; }
    gal.kvBox.hidden = false;
    if (gal.kvCur !== name) {
      gal.kv.pause();
      gal.kvCur = name;
      gal.kv.poster = p;
      gal.kv.src = u;
      gal.kv.load();
    }
    kitSync();
  }
  /* Steht die Galerie neben dem Formular (Rechner)? Am Handy steht sie ueber dem Formular, dort springt sie nicht. */
  function galBeside() {
    var art = $('[data-ar-prod-art]'), holder = art && art.parentNode;
    if (!holder) return false;
    return holder.getBoundingClientRect().right <= form.getBoundingClientRect().left + 8;
  }
  function galToKit() {
    if (!gal || !gal.kitAt || !gal.car || ARAO.viewerOpen || gal.cur === gal.kitAt) return;
    if (galBeside()) gal.car.show(gal.kitAt, true);
  }
  /* "See all 8 graphics": Viewer beim ersten Bild des gewaehlten Stils (das Video steht davor) */
  function openAll(btn) {
    var kit = ARAO.data().kit, st = kit && (kit.styles || []).filter(function (x) { return x.key === S.style; })[0], at = 0;
    if (st) (st.items || []).some(function (it, i) { if (it.t === 'i') { at = i; return true; } return false; });
    ARAO.openViewer('kit', at, btn);
  }
  function selectStyle(name) {
    S.style = name;
    $$('[data-ao-style]').forEach(function (t) {
      var on = t.getAttribute('data-ao-style') === name;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    /* Fallback-Vorschau im Handy der Karte (steht nur da, wenn es fuer den Stil kein Beispielvideo gibt) folgt dem Stil */
    var src = $('[data-ao-tiles] [data-ao-style="' + name + '"] .ar-ao-pv', root), th = $('[data-ao-thumb="kit"]', root);
    if (src && th) { th.textContent = ''; th.appendChild(src.cloneNode(true)); }
    ktFanFor(name);
    pvFor(name);
    kitGal(name);
  }
  doc.addEventListener('click', function (ev) {
    var kt = ev.target.closest && ev.target.closest('[data-ao-kt]');
    if (kt && root.contains(kt)) { ktSet(!ktOpenS); return; }
    var all = ev.target.closest && ev.target.closest('[data-ao-all]');
    if (all && root.contains(all)) { openAll(all); return; }
    var t = ev.target.closest && ev.target.closest('[data-ao-style]');
    if (t) {
      selectStyle(t.getAttribute('data-ao-style'));
      if (root.contains(t) && t.closest('[data-ao-tiles]')) galToKit();
      return;
    }
  });
  radios($('[data-ao-tiles]', root), '[data-ao-style]', function (n) { selectStyle(n.getAttribute('data-ao-style')); });
  if (card.kit) selectStyle('xerox');
  if (upsell) radios($('[data-ao-up-tiles]', upsell), '[data-ao-style]', function (n) { selectStyle(n.getAttribute('data-ao-style')); });

  /* ------------------------------------------------------------ Galerie links (A13): Buehne 1:1, EINE feste Zeile darunter, dann Pfeil, Mini-Vorschaubilder, Pfeil
     Das Produktbild (mit Kippeffekt) bleibt Folie 0 und sitzt unveraendert in seinem Kasten. Die Buehne der Add-on-Folien hat dieselbe Breite und ein festes Seitenverhaeltnis 1:1 (Inhalt contain),
     beide liegen an derselben Stelle: das Umschalten verschiebt nichts. Darunter steht auf JEDER Folie dieselbe Zeile mit fester Hoehe: links Titel und graue Unterzeile (je eine Zeile, Rest mit Ellipse),
     rechts der Knopf. Hat die Folie keinen Knopf, bleibt sein Platz leer (visibility hidden). Keine Punkte, kein Zaehler. Wischen am Handy ueber die ganze Galerie. */
  var gal = null;
  var HINT_FALLBACK = 'I set your name and title by hand on the real file.';
  function initGallery() {
    var tpl = $('template[data-ao-gal]', root), art = $('[data-ar-prod-art]');
    if (!tpl || !art || !art.parentNode) return;
    var holder = art.parentNode, hint = $('[data-ar-prod-hint]', holder);
    var hintText = ((hint && hint.textContent) || '').trim() || HINT_FALLBACK;
    var stage = doc.createElement('div'); stage.className = 'ar-ao-gal__stage ar-ao-gal-off'; stage.tabIndex = 0;
    stage.setAttribute('role', 'group'); stage.setAttribute('aria-roledescription', 'carousel'); stage.setAttribute('aria-label', 'Product gallery');
    stage.appendChild(tpl.content.cloneNode(true));
    var slides = $$('[data-ao-slide]', stage);
    if (!slides.length) return;
    /* A19: die Kit-Folie bekommt Bild und Mini-Vorschaubild des gewaehlten Stils (sonst Xerox, sonst der erste Stil mit Adresse) */
    var kitEl = slides.filter(function (e) { return e.hasAttribute('data-ao-kitslide'); })[0] || null;
    if (kitEl) {
      var v0 = kitVals(kitEl, S.style) || kitVals(kitEl, 'xerox');
      for (var si = 0; !v0 && si < STYLES.length; si++) v0 = kitVals(kitEl, STYLES[si]);
      if (v0) {
        kitImg(kitEl, v0);
        kitEl.setAttribute('data-thumb', v0.t || v0.src); kitEl.setAttribute('data-thumb2', v0.t2); kitEl.setAttribute('data-thumb-fb', v0.src);
      }
    }
    var meta = doc.createElement('div'); meta.className = 'ar-ao-gal__meta';
    var txt = doc.createElement('div'); txt.className = 'ar-ao-gal__txt'; txt.setAttribute('aria-live', 'polite');
    var capT = doc.createElement('b'); capT.className = 'ar-ao-gal__t';
    var capS = doc.createElement('span'); capS.className = 'ar-ao-gal__s';
    txt.appendChild(capT); txt.appendChild(capS);
    var addB = doc.createElement('button'); addB.type = 'button'; addB.className = 'ar-ao-gal__add'; addB.textContent = 'Add to my order';
    meta.appendChild(txt); meta.appendChild(addB);
    var ctl = doc.createElement('div'); ctl.className = 'ar-ao-gal__ctl'; ctl.setAttribute('role', 'group'); ctl.setAttribute('aria-label', 'Product gallery controls');
    function mkNav(dir) {
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'ar-ao-gal__nav ar-ao-gal__nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.appendChild(ARAO.svgArrow(dir));
      return b;
    }
    var prevB = mkNav('prev'), nextB = mkNav('next');
    var thumbs = doc.createElement('div'); thumbs.className = 'ar-ao-gal__thumbs'; thumbs.setAttribute('role', 'group'); thumbs.setAttribute('aria-label', 'Gallery pictures');
    ctl.appendChild(prevB); ctl.appendChild(thumbs); ctl.appendChild(nextB);
    /* A15: Wischen in der Vorschaureihe scrollt nur die Reihe und blaettert nicht zusaetzlich die Galerie (das Karussell hoert am ganzen Kasten auf Wischen) */
    thumbs.addEventListener('pointerdown', function (ev) { ev.stopPropagation(); });
    holder.insertBefore(stage, art.nextSibling);
    holder.insertBefore(meta, stage.nextSibling);
    holder.insertBefore(ctl, meta.nextSibling);
    holder.classList.add('ar-ao-gal-on');
    /* Der Satz unter dem Produktbild steht jetzt in der festen Zeile; ar.js schaltet das Original weiter per hidden, es bleibt dauerhaft unsichtbar */
    if (hint) {
      hint.classList.add('ar-ao-gal-off');
      if (window.MutationObserver) new MutationObserver(function () { galSync(); }).observe(hint, { attributes: true, attributeFilter: ['hidden'] });
    }
    gal = { slides: slides, cur: 0, capT: capT, capS: capS, addB: addB, hint: hint, hintText: hintText, kitEl: kitEl, kitAt: kitEl ? slides.indexOf(kitEl) + 1 : 0, kitTh: null,
             kv: null, kvBox: null, kvOn: false, kvCur: '', kvVis: false, kvBad: {} };
    /* A24: Video der Kit-Folie (Handy im Brett) */
    var kvBox = kitEl && $('[data-ao-kv]', kitEl), kv = kvBox && $('video', kvBox);
    if (kv) {
      gal.kv = kv; gal.kvBox = kvBox;
      /* kein <source>: die Quelle kommt als src erst beim ersten Zeigen der Folie (ein leeres <source> loeste sofort einen Fehler aus) */
      kv.addEventListener('error', function () { if (!gal.kvCur) return; gal.kvBad[gal.kvCur] = true; kvFor(S.style); });
      if (window.IntersectionObserver) new IntersectionObserver(function (en) { gal.kvVis = halfVisible(en[en.length - 1]); kitSync(); }, { threshold: [0, 0.25, 0.5, 0.75, 1] }).observe(stage);
    }
    /* Mini-Vorschaubilder: das Produktbild und je Folie ein Quadrat (A15: 72 bis 80 px, Handy 58 px), das aktive mit Lime-Rand */
    var ths = [], later = [];
    /* Die Mini-Bilder laden erst nach dem Laden der Seite (oder beim ersten Blick in die Galerie), damit sie den ersten Bildschirm nicht bremsen.
       A14: data-thumb ist die verkleinerte Fassung (160x, asset_img_url); data-thumb-fb das Original, falls die kleine Fassung nicht laedt.
       A15: dazu data-thumb2 (240x) als srcset 160w/240w, sizes 76 px (Rechner) bzw. 58 px (Handy). */
    function mkThumb(src, label, i, defer, fb, src2) {
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'ar-ao-gal__th';
      b.setAttribute('aria-label', 'Show ' + label);
      var im = doc.createElement('img'); im.alt = ''; im.width = 76; im.height = 76; im.loading = 'lazy'; im.decoding = 'async';
      /* A19: die Kit-Folie wechselt ihr Mini-Vorschaubild mit dem Stil (im.__cur = { src, src2, fb }), die anderen behalten ihre festen Adressen */
      im.addEventListener('error', function () {
        var c = im.__cur || { src: src, fb: fb };
        if (c.fb && c.fb !== c.src && !im.__fb) { im.__fb = true; im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = c.fb; }
      });
      function put() {
        var c = im.__cur || { src: src, src2: src2 };
        im.__fb = false; im.__done = true;
        if (c.src2 && c.src2 !== c.src) { im.sizes = '(min-width: 760px) 76px, 58px'; im.srcset = c.src + ' 160w, ' + c.src2 + ' 240w'; }
        else { im.removeAttribute('srcset'); im.removeAttribute('sizes'); }
        im.src = c.src;
      }
      im.__put = function () { if (im.__done) put(); };
      if (defer) later.push(put); else put();
      b.appendChild(im);
      b.addEventListener('click', function () { gal.car.show(i, true); });
      thumbs.appendChild(b); ths.push(b);
      return im;
    }
    function thumbsNow() { var l = later; later = []; l.forEach(function (fn) { fn(); }); }
    gal.thumbsNow = thumbsNow;
    mkThumb(root.getAttribute('data-ao-cover-thumb') || ($('img', art) || {}).src || '', 'the cover', 0, false, null, root.getAttribute('data-ao-cover-thumb2'));
    slides.forEach(function (el, k) {
      var tim = mkThumb(el.getAttribute('data-thumb') || '', (el.getAttribute('data-label') || 'picture').toLowerCase(), k + 1, true, el.getAttribute('data-thumb-fb'), el.getAttribute('data-thumb2'));
      if (el === kitEl) gal.kitTh = tim;
    });
    if (doc.readyState === 'complete') setTimeout(thumbsNow, 150);
    else window.addEventListener('load', function () { setTimeout(thumbsNow, 150); });
    var car = carousel({
      stage: holder, bare: true, prevBtn: prevB, nextBtn: nextB,
      count: function () { return slides.length + 1; },
      apply: function (i) {
        gal.cur = i;
        if (i > 0 && gal.thumbsNow) gal.thumbsNow();
        if (gal.kv && gal.kitAt && i === gal.kitAt && !gal.kvOn) { gal.kvOn = true; kvFor(S.style); }
        art.classList.toggle('ar-ao-gal-off', i > 0);
        stage.classList.toggle('ar-ao-gal-off', i === 0);
        stack(slides, i - 1);
        ths.forEach(function (b, k) { b.classList.toggle('is-on', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        /* A15: passt die Reihe nicht, scrollt sie (nur die Reihe, nie die Seite) so, dass das aktive Bild in der Mitte steht */
        var cb = ths[i];
        if (cb && thumbs.scrollWidth > thumbs.clientWidth) thumbs.scrollLeft = cb.offsetLeft - (thumbs.clientWidth - cb.offsetWidth) / 2;
        galSync();
        kitSync();
      }
    });
    car.refresh(false);
    gal.car = car;
    kitGal(S.style);
    addB.addEventListener('click', function () {
      var el = slides[gal.cur - 1], k = el && el.getAttribute('data-addon');
      if (!k || !card[k]) return;
      if (!S[k]) toggle(k, true);
      card[k].scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
    });
  }
  /* Titel, Unterzeile und Knopf der aktuellen Folie. Die Zeile behaelt auf jeder Folie dieselbe Hoehe, der Knopf bleibt ohne Funktion unsichtbar (nicht entfernt). */
  function galSync() {
    if (!gal) return;
    var el = gal.slides[gal.cur - 1], k = el && el.getAttribute('data-addon');
    var t, s;
    if (el) { t = el.getAttribute('data-cap') || ''; s = el.getAttribute('data-sub') || ''; }
    else { t = 'Your cover'; s = gal.hint && gal.hint.hidden ? '' : gal.hintText; }
    gal.capT.textContent = t; gal.capT.title = t;
    gal.capS.textContent = s; gal.capS.title = s;
    var has = !!(k && card[k]);
    gal.addB.disabled = !has;
    gal.addB.classList.toggle('is-void', !has);
    if (has) {
      gal.addB.textContent = S[k] ? 'Added ✓' : 'Add to my order';
      gal.addB.classList.toggle('is-on', !!S[k]);
    } else {
      gal.addB.classList.remove('is-on');
    }
  }

  /* ------------------------------------------------------------ Tracklist als einzelne Zeilen, per Griff sortierbar */
  var trkList = $('[data-ao-trk]', root), trkTpl = $('template[data-ao-trk-row]', root), trkAdd = $('[data-ao-trk-add]', root), trkMax = $('[data-ao-trk-max]', root), tlEl = $('[data-ao-tl]', root);
  var trkLive = $('[data-ao-trk-live]', root);
  function trkRows() { return trkList ? $$('.ar-ao-trk__row', trkList) : []; }
  function trkClean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function trkTitleOf(r) { return $('[data-ao-trk-title]', r); }
  function trkLines() {
    var out = [];
    trkRows().forEach(function (r) {
      var t = trkClean(trkTitleOf(r).value);
      if (!t) return;
      var f = trkClean($('[data-ao-trk-feat]', r).value).replace(/^feat\.?\s*/i, '');
      out.push((out.length + 1) + '. ' + t + (f ? ' (feat. ' + f + ')' : ''));
    });
    return out;
  }
  function trkTile() {
    if (!tlEl) return;
    var titles = [];
    trkRows().forEach(function (r) { var t = trkClean(trkTitleOf(r).value); if (t) titles.push(t); });
    $$('i', tlEl).forEach(function (el, k) { el.textContent = (k + 1) + '. ' + (titles[k] || '—'); });
  }
  function trkSay(msg) { if (trkLive) { trkLive.textContent = ''; setTimeout(function () { trkLive.textContent = msg; }, 30); } }
  function trkRenumber() {
    var rows = trkRows();
    rows.forEach(function (r, i) { $('.ar-ao-trk__n', r).textContent = (i + 1) + '.'; });
    if (trkAdd) trkAdd.disabled = rows.length >= MAX_TRACKS;
    if (trkMax) trkMax.hidden = rows.length < MAX_TRACKS;
    trkTile();
  }
  /* neue Zeile, hinter "after" (sonst am Ende), optional mit Werten */
  function trkNew(focus, after, title, feat) {
    if (!trkList || !trkTpl || trkRows().length >= MAX_TRACKS) return null;
    var li = trkTpl.content.firstElementChild.cloneNode(true);
    if (after && after.parentNode === trkList) trkList.insertBefore(li, after.nextSibling); else trkList.appendChild(li);
    if (title) trkTitleOf(li).value = title;
    if (feat) $('[data-ao-trk-feat]', li).value = feat;
    trkRenumber();
    if (focus) trkTitleOf(li).focus();
    return li;
  }
  var FEAT_RX = /\s*[(\[]\s*(?:feat\.?|ft\.?|featuring)\s+([^)\]]+?)\s*[)\]]\s*$/i;
  function trkSplit(line) {
    var t = trkClean(line).replace(/^\d{1,3}\s*[.):\-–]\s+/, ''), f = '', m = FEAT_RX.exec(t);
    if (m) { f = trkClean(m[1]); t = t.slice(0, m.index); }
    return { t: trkClean(t), f: f };
  }

  /* Ziehen: Maus sofort nach 4 px, Touch nach Long-Press (320 ms), Auto-Scroll am Rand des Fensters */
  var drag = null, raf = 0;
  function dragFlip(sib, fn) {
    var t0 = sib.getBoundingClientRect().top;
    fn();
    if (REDUCED) return;
    var dy = t0 - sib.getBoundingClientRect().top;
    if (!dy) return;
    sib.style.transition = 'none'; sib.style.transform = 'translateY(' + dy + 'px)';
    void sib.offsetHeight;
    sib.style.transition = 'transform 0.18s ease'; sib.style.transform = '';
    setTimeout(function () { sib.style.transition = ''; }, 220);
  }
  function dragApply() {
    if (!drag || !drag.active) return;
    var row = drag.row;
    row.style.transform = '';
    var nat = row.getBoundingClientRect().top;
    row.style.transform = 'translateY(' + (drag.y - drag.grab - nat) + 'px)';
    var moved = false;
    /* so lange tauschen, bis die Mitte der gezogenen Zeile zwischen den Mitten ihrer Nachbarn liegt (schnelle Bewegung ueberspringt mehrere Zeilen) */
    for (var guard = 0; guard < 40; guard++) {
      var rows = trkRows(), i = rows.indexOf(row), rr = row.getBoundingClientRect(), center = rr.top + rr.height / 2, swapped = false;
      var prev = rows[i - 1], next = rows[i + 1];
      if (prev) { var pr = prev.getBoundingClientRect(); if (center < pr.top + pr.height / 2) { dragFlip(prev, function () { trkList.insertBefore(row, prev); }); swapped = true; } }
      if (!swapped && next) { var nr = next.getBoundingClientRect(); if (center > nr.top + nr.height / 2) { dragFlip(next, function () { trkList.insertBefore(next, row); }); swapped = true; } }
      if (!swapped) break;
      moved = true;
      row.style.transform = '';
      var nat1 = row.getBoundingClientRect().top;
      row.style.transform = 'translateY(' + (drag.y - drag.grab - nat1) + 'px)';
    }
    if (moved) {
      trkRenumber();
      row.style.transform = '';
      var nat2 = row.getBoundingClientRect().top;
      row.style.transform = 'translateY(' + (drag.y - drag.grab - nat2) + 'px)';
    }
  }
  function dragScroll() {
    raf = 0;
    if (!drag || !drag.active) return;
    var h = window.innerHeight, edge = 80, dy = 0;
    if (drag.y < edge) dy = -Math.ceil((edge - drag.y) / edge * 18);
    else if (drag.y > h - edge) dy = Math.ceil((drag.y - (h - edge)) / edge * 18);
    if (dy) { window.scrollBy(0, dy); dragApply(); }
    raf = requestAnimationFrame(dragScroll);
  }
  function dragBegin() {
    if (!drag || drag.active) return;
    drag.active = true;
    clearTimeout(drag.timer);
    drag.grab = drag.y - drag.row.getBoundingClientRect().top;
    drag.row.classList.add('is-drag');
    trkList.classList.add('is-sorting');
    doc.documentElement.classList.add('ar-ao-dragging');
    try { drag.g.setPointerCapture(drag.id); } catch (e) {}
    if (drag.touch && navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
    dragApply();
    if (!raf) raf = requestAnimationFrame(dragScroll);
  }
  function dragEnd() {
    if (!drag) return;
    var d = drag; drag = null;
    clearTimeout(d.timer);
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
    if (!d.active) return;
    d.row.style.transform = '';
    d.row.classList.remove('is-drag');
    trkList.classList.remove('is-sorting');
    doc.documentElement.classList.remove('ar-ao-dragging');
    trkRenumber();
    try { d.g.releasePointerCapture(d.id); } catch (e) {}
    d.g.focus({ preventScroll: true });
    trkSay('Track moved to position ' + (trkRows().indexOf(d.row) + 1) + ' of ' + trkRows().length);
  }
  if (trkList && trkTpl) {
    for (var ti = 0; ti < 3; ti++) trkNew(false);
    if (trkAdd) trkAdd.addEventListener('click', function () { trkNew(true); hideErr(); });
    trkList.addEventListener('input', function (ev) { if (ev.target.classList) ev.target.classList.remove('is-bad'); if (errEl) errEl.hidden = true; trkTile(); });
    trkList.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-ao-trk-rm]');
      if (!b) return;
      var row = b.closest('.ar-ao-trk__row'), rows = trkRows(), i = rows.indexOf(row);
      if (i < 0) return;
      if (rows.length > 1) {
        var near = rows[i + 1] || rows[i - 1];
        trkList.removeChild(row); trkRenumber();
        if (near) trkTitleOf(near).focus();
        trkSay('Track removed');
      } else {
        trkTitleOf(row).value = ''; $('[data-ao-trk-feat]', row).value = ''; trkTile(); trkTitleOf(row).focus();
      }
    });
    /* Enter im Titelfeld legt die naechste Zeile an (statt das Formular abzusenden) */
    trkList.addEventListener('keydown', function (ev) {
      var t = ev.target;
      if (t && t.matches && t.matches('[data-ao-trk-title], [data-ao-trk-feat]') && ev.key === 'Enter' && !ev.isComposing) {
        ev.preventDefault();
        var row = t.closest('.ar-ao-trk__row'), nxt = row.nextElementSibling;
        if (nxt && !trkClean(trkTitleOf(nxt).value)) trkTitleOf(nxt).focus();
        else if (trkRows().length < MAX_TRACKS) trkNew(true, row);
        else if (nxt) trkTitleOf(nxt).focus();
        return;
      }
      /* Sortieren mit der Tastatur: Griff fokussieren, Pfeil hoch oder runter */
      var g = t && t.closest && t.closest('[data-ao-trk-grip]');
      if (g && (ev.key === 'ArrowUp' || ev.key === 'ArrowDown')) {
        ev.preventDefault();
        var r = g.closest('.ar-ao-trk__row'), rows = trkRows(), i = rows.indexOf(r);
        if (ev.key === 'ArrowUp' && i > 0) trkList.insertBefore(r, rows[i - 1]);
        else if (ev.key === 'ArrowDown' && i < rows.length - 1) trkList.insertBefore(rows[i + 1], r);
        else return;
        trkRenumber(); g.focus();
        trkSay('Track moved to position ' + (trkRows().indexOf(r) + 1) + ' of ' + rows.length);
      }
    });
    /* Mehrere Zeilen einfuegen: jede Zeile wird ein Track, "1. " vorn und "(feat. X)" hinten werden erkannt */
    trkList.addEventListener('paste', function (ev) {
      var t = ev.target;
      if (!t || !t.matches || !t.matches('[data-ao-trk-title]')) return;
      var txt = ((ev.clipboardData || window.clipboardData) || { getData: function () { return ''; } }).getData('text') || '';
      if (!/[\r\n]/.test(txt.replace(/[\r\n\s]+$/, ''))) return;
      var lines = txt.split(/\r?\n/).map(trkClean).filter(Boolean).map(trkSplit).filter(function (x) { return x.t; });
      if (!lines.length) return;
      ev.preventDefault();
      var row = t.closest('.ar-ao-trk__row'), last = row, made = 0;
      lines.forEach(function (x, k) {
        if (k === 0 && !trkClean(t.value)) { t.value = x.t; if (x.f) $('[data-ao-trk-feat]', row).value = x.f; made++; return; }
        var li = trkNew(false, last, x.t, x.f);
        if (li) { last = li; made++; }
      });
      trkTile();
      trkTitleOf(last).focus();
      if (made < lines.length) trkSay('Only ' + MAX_TRACKS + ' tracks fit, the rest was left out');
      else trkSay(made + ' tracks added');
      if (errEl) errEl.hidden = true;
    });
    /* Ziehen am Griff */
    trkList.addEventListener('pointerdown', function (ev) {
      var g = ev.target.closest && ev.target.closest('[data-ao-trk-grip]');
      if (!g || drag) return;
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      var row = g.closest('.ar-ao-trk__row');
      drag = { row: row, g: g, id: ev.pointerId, x0: ev.clientX, y0: ev.clientY, y: ev.clientY, active: false, timer: 0, touch: ev.pointerType === 'touch', grab: 0 };
      if (drag.touch) drag.timer = setTimeout(dragBegin, 320);
      else { try { g.setPointerCapture(ev.pointerId); } catch (e) {} g.focus({ preventScroll: true }); }
    });
    trkList.addEventListener('contextmenu', function (ev) { if (ev.target.closest && ev.target.closest('[data-ao-trk-grip]')) ev.preventDefault(); });
    window.addEventListener('pointermove', function (ev) {
      if (!drag || ev.pointerId !== drag.id) return;
      drag.y = ev.clientY;
      if (!drag.active) {
        var mv = Math.max(Math.abs(ev.clientX - drag.x0), Math.abs(ev.clientY - drag.y0));
        if (drag.touch) { if (mv > 9) { clearTimeout(drag.timer); drag = null; } }
        else if (mv > 4) dragBegin();
        return;
      }
      ev.preventDefault();
      dragApply();
    });
    window.addEventListener('pointerup', function (ev) { if (drag && ev.pointerId === drag.id) dragEnd(); });
    window.addEventListener('pointercancel', function (ev) { if (drag && ev.pointerId === drag.id) dragEnd(); });
    /* Touch: nach dem Long-Press darf die Seite nicht mehr scrollen, nur die Auto-Scroll-Schleife bewegt sie.
       Der Hoerer ist nicht passiv, haengt aber nur an der Liste (Touch-Ereignisse gehen an das Element, auf dem der Finger aufsetzte), nicht mehr am ganzen Dokument. */
    trkList.addEventListener('touchmove', function (ev) { if (drag && drag.active && ev.cancelable) ev.preventDefault(); }, { passive: false });
  }

  /* ------------------------------------------------------------ Fehler */
  function hideErr() {
    if (errEl) errEl.hidden = true;
    $$('.is-bad', root).forEach(function (e) { e.classList.remove('is-bad'); });
  }
  function showErr(msg, el) {
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    if (el) {
      el.classList.add('is-bad');
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      var r = el.getBoundingClientRect();
      window.scrollTo({ top: window.scrollY + r.top - 160, behavior: 'auto' });
    }
  }
  [artistEl, titleEl].forEach(function (e) { if (e) e.addEventListener('input', function () { e.classList.remove('is-bad'); if (errEl) errEl.hidden = true; }); });

  /* ------------------------------------------------------------ Absenden */
  function coverFieldsMissing() {
    var felder = $('[data-ar-prod-fields]', form);
    if (!felder || felder.hidden) return false;
    return $$('[data-ar-req]', form).some(function (i) { return !i.disabled && !i.value.trim(); });
  }
  function addonError() {
    if (S.tracks && card.tracks && trkList && !trkLines().length) {
      var first = trkRows().filter(function (r) { return !trkClean(trkTitleOf(r).value); })[0] || trkRows()[0];
      return { msg: 'Add at least one track title.', el: first ? trkTitleOf(first) : null };
    }
    if (namesNeeded()) {
      if (artistEl && !artistEl.value.trim()) return { msg: 'Artist name and title are needed for the add-ons.', el: artistEl };
      if (titleEl && !titleEl.value.trim()) return { msg: 'Artist name and title are needed for the add-ons.', el: titleEl };
    }
    return null;
  }
  var pendingSubmitter = null;
  function upsellSeen() { try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return true; } }

  /* Erste Stelle (Capture auf window, vor ar.js): Pflichtfelder des Covers bleiben bei ar.js. Danach Add-on-Pflichtfelder, dann der Upsell. */
  window.addEventListener('submit', function (ev) {
    if (ev.target !== form) return;
    if (busy) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
    if (coverFieldsMissing()) return;
    var e = addonError();
    if (e) { ev.preventDefault(); ev.stopImmediatePropagation(); showErr(e.msg, e.el); return; }
    hideErr();
    if (S.kit || !card.kit || !upsell || upsellSeen()) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    pendingSubmitter = ev.submitter || buy;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (x) {}
    var tiles = $('[data-ao-up-tiles]', upsell), src = $('[data-ao-tiles]', root);
    tiles.textContent = '';
    $$('[data-ao-style]', src).forEach(function (t) { tiles.appendChild(t.cloneNode(true)); });
    selectStyle(S.style);
    openDlg(upsell);
  }, true);

  if (upsell) upsell.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ao-up]');
    if (!b) return;
    if (b.getAttribute('data-ao-up') === 'add') { toggle('kit', true); selectStyle(S.style); }
    closeDlg(upsell, true);
    var sub = pendingSubmitter || buy;
    pendingSubmitter = null;
    setTimeout(function () { if (form.requestSubmit) form.requestSubmit(sub); else form.submit(); }, 30);
  });

  /* Zeilen fuer den Warenkorb: nur Add-ons mit echter Variant-ID (keine Vorschau-Zeilen) */
  function addonItems() {
    var artist = '', title = '';
    if (coverHasNames()) { artist = coverArtist.value.trim(); title = coverTitle ? coverTitle.value.trim() : ''; }
    else { artist = artistEl ? artistEl.value.trim() : ''; title = titleEl ? titleEl.value.trim() : ''; }
    var items = [];
    function line(k, props) {
      var c = card[k];
      if (!c || !S[k] || c.hasAttribute('data-preview')) return;
      var id = parseInt(c.getAttribute('data-variant-id'), 10);
      if (!id) return;
      var p = { _for: handle };
      for (var a in props) if (props[a]) p[a] = props[a];
      if (artist) p['Artist Name'] = artist;
      if (title) p['Title'] = title;
      items.push({ id: id, quantity: 1, properties: p });
    }
    line('kit', { Style: nameOf('[data-ao-style="%"]', 'data-name', S.style) });
    line('banner', {});
    line('tracks', {
      Tracks: trkLines().join('\n'),
      Notes: notesEl ? notesEl.value.trim() : ''
    });
    return items;
  }

  var busy = false, buyWasOff = false;
  function freigeben() {
    busy = false;
    if (buy && buyWasOff) { buy.disabled = false; }
    buyWasOff = false;
    if (buy && buy.getAttribute('data-text')) buy.textContent = buy.getAttribute('data-text');
    $$('.ar-upload.is-busy', form).forEach(function (u) { u.classList.remove('is-busy'); });
  }
  /* Leere Datei- und freiwillige Textfelder gehen nicht mit (wie in ar.js): beim spaeten Absenden erneut sicherstellen */
  function leereFelderAus() {
    $$('input[type=file]', form).forEach(function (i) { if (!i.disabled && !(i.files && i.files[0])) i.disabled = true; });
    $$('input[type=text][name^="properties["]', form).forEach(function (i) { if (!i.disabled && !i.hasAttribute('data-ar-req') && !i.value.trim()) i.disabled = true; });
  }

  /* Zweite Stelle (Bubble auf window, nach ar.js): ar.js hat die Pflichtfelder des Covers geprueft und ggf. abgebrochen.
     Jetzt zuerst die Add-ons in den Warenkorb, dann das Cover-Formular klassisch. */
  window.addEventListener('submit', function (ev) {
    if (ev.target !== form || ev.defaultPrevented) return;
    var items = addonItems();
    if (!items.length) return;
    ev.preventDefault();
    if (busy) return;
    busy = true;
    if (buy && !buy.disabled) { buy.disabled = true; buyWasOff = true; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r; })
      .then(function () {
        leereFelderAus();
        form.submit();
      })
      .catch(function () {
        freigeben();
        showErr('The add-ons could not be added to your cart. Please try again.', null);
      });
  });

  /* Zurueck per Browser-Verlauf: nichts doppelt hinzufuegen, Auswahl zuruecksetzen */
  window.addEventListener('pageshow', function (ev) {
    freigeben();
    if (ev.persisted) KEYS.forEach(function (k) { if (S[k]) toggle(k, false); });
  });

  /* ------------------------------------------------------------ A30: EINE Kaufleiste am Handy mit dem echten Gesamtpreis
     Die eigene schwebende Summenleiste (frueher .ar-ao-fsum) ist weg. Die Kaufleiste [data-ar-buybar] (sections/ar-product.liquid) zeigt den Preis in [data-ar-buybar-price]; ar.js schreibt dort in leiste()
     den Coverpreis hinein, sobald sich Variante, Lizenz oder Eingaben aendern. barSync schreibt danach den Gesamtpreis (Cover + gewaehlte Add-ons) und blendet darunter klein "incl. add-ons" ein.
     Ein MutationObserver auf dem Preisfeld stellt den Gesamtpreis nach jedem Schreiben von ar.js wieder her. Endlosschleife ausgeschlossen: es wird nur geschrieben, wenn der Text abweicht.
     Das Zahlenformat (Komma/Punkt, Waehrungszeichen) kommt vom Preisfeld des Covers. Ohne Add-on steht wieder der Coverpreis ohne Zusatz. */
  var barPrice = $('[data-ar-buybar-price]'), barNote = null, barAny = false, barTotal = 0;
  function priceLike(c) {
    var s = (priceEl && priceEl.textContent) || '', m = /\d+([.,])\d{2}/.exec(s);
    if (!m) return money(c);
    return s.replace(m[0], (c / 100).toFixed(2).replace('.', m[1]));
  }
  function barWrite() {
    if (!barPrice) return;
    var want = barAny ? priceLike(barTotal) : ((priceEl && priceEl.textContent) || '');
    if (want && barPrice.textContent !== want) barPrice.textContent = want;
    if (barNote) barNote.hidden = !barAny;
  }
  function barSync(any, total) {
    if (!barPrice) return;
    if (!barNote && barPrice.parentNode) {
      barNote = doc.createElement('small');
      barNote.className = 'ar-ao-barnote';
      barNote.textContent = 'incl. add-ons';
      barNote.hidden = true;
      barPrice.parentNode.appendChild(barNote);
    }
    barAny = !!any; barTotal = total;
    barWrite();
  }
  if (barPrice && window.MutationObserver) new MutationObserver(function () { barWrite(); }).observe(barPrice, { childList: true, characterData: true, subtree: true });

  /* ------------------------------------------------------------ Variante B (Standard): nummerierte Schritte, ruhige Summe ueber dem Kaufknopf */
  if (UI === '2') {
    var fields = $('[data-ar-prod-fields]', form);
    if (fields && fields.parentNode) {
      var h = doc.createElement('span');
      h.className = 'ar-opt__l ar-ao-stephead';
      h.textContent = 'Your name';
      fields.parentNode.insertBefore(h, fields);
    }
    if (sumEl && buy && buy.parentNode) { sumEl.classList.add('ar-ao__sum--calm'); buy.parentNode.insertBefore(sumEl, buy); }
  }

  initGallery();
  update();
  ready = true;
})();
